import React, { ReactElement, useCallback, useEffect } from 'react';
import {
  Text,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  WrapItem,
  Wrap,
  IconButton,
} from '@chakra-ui/react';
import { RangeModifier } from 'react-day-picker/types/Modifiers';
import { MdDateRange, AiOutlineClose, HiOutlineChevronRight } from 'react-icons/all';

interface ModalProps {
  children: React.ReactNode;
  textBtn: string;
  selectedDateRange: RangeModifier;
  value: ReactElement<any, any>;
  switchBookingCalendarModal: boolean;
  handleBookingCalendarModal: () => void;
}

export const ModalView = (props: ModalProps): JSX.Element => {
  const {
    textBtn,
    selectedDateRange,
    children,
    value,
    switchBookingCalendarModal,
    handleBookingCalendarModal,
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    switchBookingCalendarModal && onOpen();
  }, [switchBookingCalendarModal]);

  const closeModalBookingCalendar = useCallback(() => {
    onClose();
    handleBookingCalendarModal();
  }, []);

  return (
    <>
      <Wrap w={'100%'}>
        <WrapItem flex={1}>
          <Button
            rightIcon={<HiOutlineChevronRight />}
            w={'100%'}
            variant="ghost"
            fontSize={'15px'}
            colorScheme={'blue'}
            onClick={onOpen}
            cursor={'pointer'}
            justifyContent={'space-between'}>
            {value && selectedDateRange.from ? value : 'Bitte wählen Sie einen Reisezeitraum aus.'}
          </Button>
        </WrapItem>
      </Wrap>
      <Modal
        onClose={closeModalBookingCalendar}
        isOpen={isOpen}
        size={'full'}
        motionPreset={'none'}>
        <ModalOverlay />
        <ModalContent m={0} borderRadius={0} pb={16}>
          <HStack
            position={'fixed'}
            w={'100%'}
            justify={'space-between'}
            pl={2}
            bgColor={'white'}
            zIndex={2}
            shadow={'lg'}
            h={'50px'}>
            <Text textStyle={'category.primary'} fontSize={'20px'}>
              {textBtn}
            </Text>
            <IconButton
              fontSize={'20px'}
              onClick={closeModalBookingCalendar}
              borderRadius={'none'}
              colorScheme={'blue'}
              icon={<AiOutlineClose />}
              aria-label={'close dayPicker in details'}
              variant="ghost"
              h={'100%'}
            />
          </HStack>

          <ModalBody pt={'66px'}>{children}</ModalBody>

          <HStack
            width={'100%'}
            justifyContent={'flex-end'}
            display={isOpen ? 'flex' : 'none'}
            position={'fixed'}
            bottom={0}
            zIndex={2}
            backgroundColor={'var(--chakra-colors-white)'}
            boxShadow={'0 -12px 10px -3px rgba(0, 0, 0, 0.1), 0 0 4px -2px rgba(0, 0, 0, 0.5)'}
            padding={'10px 0'}
            paddingRight={'var(--chakra-space-4)'}
            right={0}
            left={0}>
            <Button
              variant={'primary'}
              onClick={closeModalBookingCalendar}
              colorScheme={'blue'}
              alignSelf={'flex-end'}>
              Übernehmen
            </Button>
          </HStack>
        </ModalContent>
      </Modal>
    </>
  );
};
